import {GradePromotionResponse, GradePromotionSummary, GrowthAutomationMode} from './grade-growth.model';
import {dealPayrollGradeKey} from 'app/models/deal-payroll-presentation';
import {growthReasonKey} from './grade-growth-presentation';

const FIRST = 0;
const UNKNOWN = 'UNKNOWN';
const COMMITTED = 'COMMITTED';
const MODES = ['DISABLED', 'ENABLED'];
const MODE_PREFIX = 'GRADE_GROWTH_AUTOMATION_';
const STATE_PREFIX = 'GRADE_GROWTH_AUTOMATIC_';
const STATES = ['RETRY_PENDING', 'BLOCKED', 'APPLYING', 'COMMITTED', 'RECONCILIATION_REQUIRED',
  'AWAITING_CONFIRMATION', 'AWAITING_SOURCE', 'REJECTED', 'CANCELLED'];
const UNAUTHORIZED = 401;
const FORBIDDEN = 403;
const NOT_FOUND = 404;
const INVALID = 400;
const CONFLICT = 409;
const UNAVAILABLE = 503;
const HEAD_STATE_PREFIX = 'GRADE_GROWTH_PROMOTION_';
const SESSION_EXPIRED_KEY = 'GRADE_GROWTH_SESSION_EXPIRED';
const DENIED_KEY = 'GRADE_GROWTH_PROMOTION_DENIED';
const NOT_FOUND_KEY = 'GRADE_GROWTH_PROMOTION_NOT_FOUND';
const UNKNOWN_REASON_KEY = 'GRADE_GROWTH_REASON_UNKNOWN';
const INVALID_KEY = 'GRADE_GROWTH_PROMOTION_INVALID';
const CHANGED_KEY = 'GRADE_GROWTH_REASON_CONFIRMATION_CHANGED';
const UNAVAILABLE_KEY = 'GRADE_GROWTH_PROMOTION_UNAVAILABLE';
const READ_ERROR_KEY = 'GRADE_GROWTH_PROMOTION_READ_ERROR';

export interface GrowthPromotionView {
  summary: GradePromotionSummary;
  stateKey: string;
  fromKey: string;
  toKey: string;
  reasons: Array<{code: string; labelKey: string}>;
  committed: boolean;
}

export function growthAutomationKey(mode: GrowthAutomationMode): string {
  return MODE_PREFIX + (MODES.indexOf(mode) >= FIRST ? mode : UNKNOWN);
}

export function growthPromotionView(summary: GradePromotionSummary, headFlow = false): GrowthPromotionView {
  if (!summary) { return null; }
  return {summary: summary, committed: summary.state === COMMITTED,
    stateKey: (headFlow ? HEAD_STATE_PREFIX : STATE_PREFIX) + (STATES.indexOf(summary.state) >= FIRST ? summary.state : UNKNOWN),
    fromKey: dealPayrollGradeKey(summary.fromGradeCode), toKey: dealPayrollGradeKey(summary.toGradeCode),
    reasons: (summary.reasons || []).map(code => ({code: code, labelKey: growthReasonKey(code)}))};
}

export function growthOperationView(operation: GradePromotionResponse): GrowthPromotionView {
  if (!operation) { return null; }
  const summary: GradePromotionSummary = {operationId: operation.operationId, requestId: operation.requestId,
    revision: operation.revision, state: operation.state, fromGradeCode: operation.fromGradeCode,
    toGradeCode: operation.toGradeCode, effectiveFromMonth: operation.effectiveFromMonth,
    committedAt: operation.committedAt, reasons: (operation.reasons || []).map(reason => reason.code)};
  return growthPromotionView(summary, true);
}

export function growthPromotionErrorKey(status: number, code?: string): string {
  if (status === UNAUTHORIZED) { return SESSION_EXPIRED_KEY; }
  if (status === FORBIDDEN) { return DENIED_KEY; }
  if (status === NOT_FOUND) { return NOT_FOUND_KEY; }
  if (code) {
    const key = growthReasonKey(code);
    if (key !== UNKNOWN_REASON_KEY) { return key; }
  }
  if (status === INVALID) { return INVALID_KEY; }
  if (status === CONFLICT) { return CHANGED_KEY; }
  if (status === UNAVAILABLE) { return UNAVAILABLE_KEY; }
  return READ_ERROR_KEY;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/grade-growth/grade-promotion-presentation.ts